import React, { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Container } from "../../components/Container";
import {
  Box,
  Flex,
  Center,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { TabSubscriptionCancellation } from "./TabSubscriptionCancellation";
import { TabEmptyWeight } from "./TabEmptyWeight";
import { TabEmptyEvaluation } from "./TabEmptyEvaluation";
import { TabSubscriptionTrial } from "./TabSubscriptionTrial";
import { TabFewWorkouts } from "./TabFewWorkouts";
import { useStores } from "../../hooks/useStores";

export const Reports: React.FC = observer(() => {
  const { t } = useTranslation();
  const { clientsStore } = useStores();

  return (
    <Box p={30} w={"100%"}>
      <Flex mb={"20px"}>
        <Center p="4">{t("screens.reports.title")}</Center>
      </Flex>

      <Container>
        <Tabs variant="soft-rounded" colorScheme="purple" size="md" isFitted>
          <TabList mb="1em">
            <Tab>{t("screens.reports.tabsTitle.emptyWeight")}</Tab>
            <Tab>{t("screens.reports.tabsTitle.subscriptionCancellation")}</Tab>
            <Tab>{t("screens.reports.tabsTitle.emptyEvaluation")}</Tab>
            <Tab>{t("screens.reports.tabsTitle.subscriptionTrial")}</Tab>
            <Tab>{t("screens.reports.tabsTitle.fewWorkouts")}</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <TabEmptyWeight
                key={clientsStore.clientsEmptyEvaluation.length}
              />
            </TabPanel>
            <TabPanel>
              <TabSubscriptionCancellation />
            </TabPanel>
            <TabPanel>
              <TabEmptyEvaluation />
            </TabPanel>
            <TabPanel>
              <TabSubscriptionTrial />
            </TabPanel>
            <TabPanel>
              <TabFewWorkouts />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </Box>
  );
});
